import { Tooltip } from '@mui/material'
import React from 'react'
import { CommonTooltipProps } from './_props'
import sxs from './_sxs'

const CommonTooltip: React.FC<CommonTooltipProps> = ({ title, children, componentsProps, ...rest }) => {
    return (
        <Tooltip
            {...rest}
            title={title}
            componentsProps={{
                tooltip: {
                    ...componentsProps?.tooltip,
                    sx: {
                        ...sxs.tooltip,
                        ...componentsProps?.tooltip?.sx,
                    },
                },
                arrow: {
                    ...componentsProps?.arrow,
                    sx: {
                        ...sxs.tooltipArrow,
                        ...componentsProps?.arrow?.sx,
                    },
                },
            }}
        >
            {children}
        </Tooltip>
    )
}

export default CommonTooltip
